import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { parseDate } from "@lyfegen-platform/utils";
import { format, isValid } from "date-fns";
import * as Yup from "yup";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { TrFun } from "../utils/types";
import { GeneralFieldController } from "./general-field-controller";

export class SecondaryInterventionDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translate: TrFun): Yup.AnySchema {
		return (super.createValidationRule(initialData, translate) as Yup.DateSchema)
			.when([AttributeIdentifiers.RecurrenceDate], (recurrenceDate: Date, schema: Yup.DateSchema) => {
				return isValid(recurrenceDate)
					? schema.min(
							recurrenceDate,
							`${translate("must-be-after-rec-date")} - ${format(parseDate(recurrenceDate), "dd.MM.yyyy")}`
					  )
					: schema.min(new Date(), translate("must-be-after-rec-date"));
			})
			.max(new Date(), translate("cannot-be-greater-than-today"));
	}

	override useControlProps(): FlexControlProps {
		return {
			cannotBeFuture: true,
		};
	}
}
